/**
 * The site session id: one random id per browser tab, kept in sessionStorage.
 *
 * SiteTrafficBeacon stamps it on every site_traffic_views row, and the sign-up
 * attribution (src/lib/attribution) keeps it with each touch, so an account's
 * row in signup_attribution can be joined to the page views that led to it.
 */

export const SITE_SESSION_KEY = 'fly_site_session_v1';

export function getSiteSessionId(): string {
  try {
    let id = sessionStorage.getItem(SITE_SESSION_KEY);
    if (!id) {
      id = typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `s_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem(SITE_SESSION_KEY, id);
    }
    return id;
  } catch {
    return 'no_session';
  }
}
